export default __webpack_public_path__ + "608cf735785a699c5ca90de2e74b81e9.gif";